// prutl-frontend-npm6node14/src/pages/SponsorManagement.jsx

import React from 'react';
import SponsorList from '../components/sponsorManagement/SponsorList.jsx';

const SponsorManagement = () => {
  return (
    <div className="sponsorManagementContainer">
      <h1>Sponsor Management</h1>
      <SponsorList />
    </div>
  );
};

export default SponsorManagement;
